import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import UIImage from 'UIComponents/image/UIImage';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { H6 } from 'UIComponents/elements/headings';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { getProductLineIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { Colgroup, FixedTableLayout, StyledBreakString, TBody, THead } from './SharedComponents';
import { CommerceFeatures, getEnrolledProductLineFeatureAccessLevels } from './CommerceFeatureTableConfig';
import CommerceFeatureTableRow from './CommerceFeatureTableRow';
import UITruncateString from 'UIComponents/text/UITruncateString';
import debounce from 'react-utils/debounce';
const HeaderSection = styled.div.withConfig({
  displayName: "CommerceFeatureTableModal__HeaderSection",
  componentId: "s1tsmn-0"
})(["box-shadow:0 2px 4px 0 rgba(37,37,37,0.2);z-index:100;"]);
const ModalHeader = styled.div.withConfig({
  displayName: "CommerceFeatureTableModal__ModalHeader",
  componentId: "s1tsmn-1"
})(["text-align:center;background-color:", ";padding:20px 0;& > h3{margin:0;}img{height:20px;}"], GYPSUM);

function CommerceFeatureTableModal({
  onCloseClick
}) {
  const [width, setWidth] = useState(window.innerWidth);
  const accessLevels = getEnrolledProductLineFeatureAccessLevels(COMMERCE);
  const icons = getProductLineIcons();
  useEffect(() => {
    getUsageTracker().track('modalInteraction', {
      action: 'viewed',
      modalName: 'compare-feature-modal',
      hub: COMMERCE
    });
  }, []);
  useEffect(() => {
    const resizeWindow = debounce(() => setWidth(window.innerWidth), 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);

  const handleModalClose = () => {
    getUsageTracker().track('modalInteraction', {
      modalName: 'compare-feature-modal',
      action: 'closed',
      hub: COMMERCE
    });
    onCloseClick();
  };

  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: '100%',
    style: {
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsx(HeaderSection, {
      children: /*#__PURE__*/_jsxs(ModalHeader, {
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-2 m-bottom-2",
          src: COMMERCE in icons && icons[COMMERCE]
        }), /*#__PURE__*/_jsx(H3, {
          className: "display-inline",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.commerce.pageTitle"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: handleModalClose
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "p-x-0",
      children: [/*#__PURE__*/_jsxs(FixedTableLayout, {
        bordered: false,
        hover: false,
        className: "m-top-8",
        children: [/*#__PURE__*/_jsx(Colgroup, {
          columns: accessLevels.length + 1
        }), /*#__PURE__*/_jsx(THead, {
          verticalAlign: "bottom",
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(H6, {
                className: "m-bottom-0",
                "aria-level": 3,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.productCatalog.tableHeader.features"
                })
              })
            }), accessLevels.map(level => {
              return /*#__PURE__*/_jsx("th", {
                scope: "col",
                className: "vertical-bottom",
                children: width < 630 ? /*#__PURE__*/_jsx(UITruncateString, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `commerceFeatureTable.headers.${level}`
                  })
                }) : /*#__PURE__*/_jsx(StyledBreakString, {
                  hyphenate: false,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `commerceFeatureTable.headers.${level}`
                  })
                })
              }, level);
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(UIScrollContainer, {
        maxHeight: 'calc(100vh - 235px)',
        scrollDirection: "vertical",
        children: /*#__PURE__*/_jsxs(FixedTableLayout, {
          bordered: false,
          children: [/*#__PURE__*/_jsx(Colgroup, {
            columns: accessLevels.length + 1
          }), /*#__PURE__*/_jsx(TBody, {
            bordered: false,
            variant: "alternating",
            children: CommerceFeatures.map(feature => {
              return /*#__PURE__*/_jsx(CommerceFeatureTableRow, {
                accessLevels: accessLevels,
                feature: feature
              }, feature.shortName);
            })
          })]
        })
      })]
    })]
  });
}

export default CommerceFeatureTableModal;